module.exports = __webpack_public_path__ + "static/media/Dayananda Pai.0b13ac58.jpg";